export default "__VITE_ASSET__CbyG0wwF__"